'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleProptype = require('react-style-proptype');

var _reactStyleProptype2 = _interopRequireDefault(_reactStyleProptype);

var _lodash = require('lodash.debounce');

var _lodash2 = _interopRequireDefault(_lodash);

var _checkbox = require('./shapes/checkbox');

var _colors = require('./colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Checkbox = function (_Component) {
  _inherits(Checkbox, _Component);

  function Checkbox() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Checkbox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call.apply(_ref, [this].concat(args))), _this), _this.debouncedChange = (0, _lodash2.default)(function (e) {
      _this.props.onChange && _this.props.onChange(e, _this.props.payload);
    }, 200, {
      leading: true,
      trailing: false
    }), _this.state = {
      hover: false
    }, _this.handleBlur = function (e) {
      _this.props.onBlur && _this.props.onBlur(e);
    }, _this.handleFocus = function (e) {
      _this.props.onFocus && _this.props.onFocus(e);
    }, _this.handleMouseOver = function () {
      _this.setState({
        hover: true
      });
    }, _this.handleMouseOut = function () {
      _this.setState({
        hover: false
      });
    }, _this.handleChange = function (e) {
      e.persist();

      _this.debouncedChange(e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Checkbox, [{
    key: 'UNSAFE_componentWillMount',
    value: function UNSAFE_componentWillMount() {
      // eslint-disable-line camelcase
      // build a unique ID for this field in case one was not provided
      // logic from https://github.com/callemall/material-ui/blob/master/src/Checkbox/Checkbox.js
      var uniqueId = this.props.label + '-' + Math.floor(Math.random() * 0xffff);
      this.uniqueId = uniqueId.replace(/[^A-Za-z0-9-]/gi, '');
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          checked = _props.checked,
          indeterminate = _props.indeterminate,
          label = _props.label,
          disabled = _props.disabled,
          className = _props.className,
          style = _props.style,
          whiteBackground = _props.whiteBackground,
          id = _props.id;
      var inputId = id || this.uniqueId;
      var backgroundColor = whiteBackground ? _colors.white : undefined;
      var image = void 0;

      if (checked) {
        image = disabled ? _react2.default.createElement(_checkbox.Checked, {
          color: _colors.alloy,
          backgroundColor: backgroundColor
        }) : _react2.default.createElement(_checkbox.Checked, {
          backgroundColor: backgroundColor
        });
      } else if (indeterminate) {
        image = disabled ? _react2.default.createElement(_checkbox.Indeterminate, {
          color: _colors.alloy,
          backgroundColor: backgroundColor
        }) : _react2.default.createElement(_checkbox.Indeterminate, {
          backgroundColor: backgroundColor
        });
      } else {
        image = disabled ? _react2.default.createElement(_checkbox.Unchecked, {
          color: _colors.alloy,
          backgroundColor: backgroundColor
        }) : this.state.hover ? _react2.default.createElement(_checkbox.Unchecked, {
          color: _colors.teal.base,
          backgroundColor: backgroundColor
        }) : _react2.default.createElement(_checkbox.Unchecked, {
          backgroundColor: backgroundColor
        });
      }

      var disabledStyle = disabled ? {
        cursor: 'not-allowed',
        pointerEvents: 'none'
      } : {};
      return _react2.default.createElement('div', {
        className: 'checkbox ' + className,
        style: _extends({}, style, disabledStyle)
      }, _react2.default.createElement('label', {
        className: 'control-label',
        htmlFor: inputId,
        onClick: disabled ? undefined : this.handleChange,
        onMouseOver: this.handleMouseOver,
        onMouseOut: this.handleMouseOut,
        style: _extends({
          paddingLeft: 0
        }, disabledStyle)
      }, _react2.default.createElement('span', {
        style: {
          position: 'relative',
          top: '3px',
          paddingRight: '10px'
        }
      }, image), _react2.default.createElement('input', {
        type: 'checkbox',
        disabled: disabled,
        checked: checked,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onChange: this.handleChange,
        style: {
          visibility: 'hidden'
        }
      }), label));
    }
  }]);

  return Checkbox;
}(_react.Component);

exports.default = Checkbox;
Checkbox.propTypes = {
  id: _propTypes2.default.string,
  checked: _propTypes2.default.bool,
  indeterminate: _propTypes2.default.bool,
  label: _propTypes2.default.node,
  disabled: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  whiteBackground: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  payload: _propTypes2.default.any,
  // eslint-disable-line react/forbid-prop-types
  onBlur: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  style: _reactStyleProptype2.default
};
Checkbox.defaultProps = {
  disabled: false,
  className: '',
  whiteBackground: false
};